import { render, staticRenderFns } from "./index.vue?vue&type=template&id=175fbaac&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=175fbaac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175fbaac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\sandy\\Desktop\\EIOSYS\\Admin\\Alembic-Grow-Admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('175fbaac')) {
      api.createRecord('175fbaac', component.options)
    } else {
      api.reload('175fbaac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=175fbaac&scoped=true", function () {
      api.rerender('175fbaac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanThumb/index.vue"
export default component.exports